import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Notice, Separator } from 'telia-front-react';
import InternetCalculatorStore from '../../../stores/InternetCalculatorStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface InternetOversoldWarningProps {
  calculatorKey: string;
  partner: boolean;
  internetCalculatorStore?: InternetCalculatorStore;
}

const InternetOversoldWarning = (props: InternetOversoldWarningProps): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;
  const { internetCalculatorStore, calculatorKey, partner } = props;
  if (!internetCalculatorStore.shouldShowOversoldWarning(calculatorKey) || partner) {
    return null;
  }
  return (
    <>
      <Separator spacing="small" color="invisible" />
      <Notice type="employee">{translate('internetAndTvCalculator.f4gOverloadedWarning')}</Notice>
      <Separator spacing="small" color="invisible" />
    </>
  );
};

export default inject('internetCalculatorStore')(observer(InternetOversoldWarning));
